import { create } from "zustand";

interface PresenceData {
  status: "available" | "limited" | "booked";
  note: string;
  untilISO: string | undefined;
  responseHours: number;
}

interface PresenceStore extends PresenceData {
  load: () => Promise<void>;
}

const DEFAULT: PresenceData = {
  status: "available",
  note: "",
  untilISO: undefined,
  responseHours: 24,
};

export const usePresenceStore = create<PresenceStore>((set) => ({
  ...DEFAULT,
  load: async () => {
    try {
      const res = await fetch("/presence.json");
      if (!res.ok) return;
      const data = (await res.json()) as Partial<PresenceData>;
      set({
        status: data.status ?? DEFAULT.status,
        note: data.note ?? DEFAULT.note,
        untilISO: data.untilISO,
        responseHours: data.responseHours ?? DEFAULT.responseHours,
      });
    } catch {
      void 0;
    }
  },
}));
